<template>
  <div class="container-fluid">
    <div class="main">
      <div class="header">
        <div class="logo">
          <img src="../assets/theme/logo.png">
        </div>
        <div class="name">
          <img src="../assets/theme/name.png">
        </div>
        <div class="social">
          <i class="fab fa-facebook-square"></i>
          <i class="fas fa-phone-square-alt"></i>
          <i class="fab fa-youtube-square"></i>
        </div>
      </div>
      <div class="content">
        <div class="l-content">
          <div class="l-bolck">
            <div class="banner">
              <img src="../assets/banner/n1.png">
            </div>
          </div>
          <TodayResult />
          <div class="l-bolck">
            <div class="banner">
              <img src="../assets/banner/n3.png">
            </div>
          </div>
        </div>
        <div class="r-content">
          <div class="banner">
            <img src="../assets/banner/n2.png">
          </div>
          <HistoryResults />
        </div>
      </div>
      <div class="content-b">
        <div class="banner">
          <img src="../assets/banner/n4.png">
        </div>
        <div class="banner">
          <img src="../assets/banner/n5.png">
        </div>
        <div class="banner">
          <img src="../assets/banner/n6.png">
        </div>
      </div>
      <div class="footer">
        Copyright 2020 ©laounion.com
      </div>
    </div>
  </div>
</template>
<script>
import TodayResult from './components/TodayResult.vue'
import HistoryResults from './components/HistoryResults.vue'

export default {
  components: {
    TodayResult,
    HistoryResults
  }
}
</script>
<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

.container-fluid {
  border-top: 10px solid #07A9E1;
  padding: 0;

  .main {
    width: 1050px;
    max-width: 100%;
    margin: 0 auto;

    .header {
      height: 153px;
      background-image: url('../assets/theme/hbg.png');
      background-repeat: repeat-y;
      background-position: center top;
      background-color: #FEFEFE;
      display: flex;
      align-items: center;
      border-bottom: 5px solid #07A9E1;

      .logo {
        height: 130px;
        width: 250px;
        text-align: center;
      }
      .name {
        max-width: 100%;
        width: 100%;
      }
      .social {
        height: 100%;
        width: 120px;
        margin-right: 10px;
        padding-top: 5px;
        text-align: right;
        i {
          margin: 0 4px;
          box-shadow: 2px 1px 10px 1px #ccc;
          font-size: 24px;
          cursor: pointer;

          &.fa-facebook-square{
            color: #4267B2;
          }
          &.fa-youtube-square {
            color: red;
          }
          &.fa-phone-square-alt {
            color: green;
          }
        }
      }
    }

    .content {
      display: flex;
      margin-top: 10px;

      .l-content {
        width: 440px;

        .now-result {
          border: 3px solid #07A9E1;
          padding: 5px;
          background-color: #FFF;
          background-image: url('../assets/theme/n.png');
          background-repeat: repeat-x;
          background-position: center bottom;
          margin-bottom: 10px;

          h2 {
            text-align: center;
            font-size: 1.3rem;
            margin-top: 10px;
          }
          h1 {
            text-align: center;
            font-size: 4rem;
            font-weight: bold;
            letter-spacing: 5px;
          }
          h3 {
            text-align: center;
            font-size: 1.2rem;
            font-weight: normal;
          }

          .table {
            background-color: #FFF;
            text-align: center;
            margin-bottom: 0px;
            tr {
              td {
                padding: 5px;
                font-size: 1.5rem;
                border: 2px solid #dee2e6;
              }
            }
          }
        }

        .l-bolck {
          margin-bottom: 10px;
          //min-height: 200px;
          border: 1px solid #eee;
          //padding: 5px;
          background-color: #FFF;
          /*background-image: url('../assets/theme/n2.png');
          background-repeat: repeat-x;
          background-position: center bottom;*/

          .banner {
            img {
              width: 100%;
              max-width: 100%;
            }
          }
        }
      }
      .r-content {
        width: calc(100% - 450px);
        margin-left: 10px;
        h2 {
          text-align: center;
          font-size: 1.5rem;
          border: 3px solid #07A9E1;
          padding: 3px;
          //margin: 0 10px 10px;
        }
        .table {
          tr {
            td {
              padding: 5px;
              text-align: center;
            }
          }
        }
        .banner {
          margin-bottom: 10px;
          img {
            width: 100%;
            max-width: 100%;
          }
        }
      }
    }

    .content-b {
      //margin-top: 15px;
      margin-right: -5px;
      margin-left: -5px;
      display: flex;

      .banner {
        width: 33.3%;
        padding: 5px;
        img {
          max-width: 100%;
          border: 1px solid #EEE;
        }
      }
    }

    .footer {
      margin-top: 15px;
      //margin-bottom: 15px;
      text-align: center;
      background-color: #07A9E1;
      padding: 10px;
      color: #FFF;
    }
  }
}

@media only screen and (max-width:767px) {
  .container-fluid .main .header {
    height: 100px;
    .logo {
      height: 100px;
      width: 180px;
      img {
        height: 80px;
        margin-top: 10px;
      }
    }
    .name {
      img {
        height: 60px;
      }
    }
    .social {
      i {
        font-size: 20px;
      }
    }
  }
  .container-fluid .main .content .r-content {
    div {
      margin: 0 5px;
    }
  }
  .container-fluid .main .content {
    display: block;
    .l-content {
      width: 100%;
    }
    .r-content {
      width: 100%;
      margin-left: 0px;
      margin-top: 15px;
    }
  }
}

@media only screen and (max-width:500px) {
  .container-fluid .main .header {
    height: 80px;
    .logo {
      height: 80px;
      width: 120px;
      img {
        height: 60px;
        margin-top: 10px;
      }
    }
    .name {
      img {
        width: 280px;
        height: auto;
      }
    }
    .social {
      display: none;
    }
  }
  .container-fluid .main .content .r-content {
    table.table {
      font-size: 15px;
    }
    h2 {
      margin: 10px 0;
      border: 0;
    }
  }
  .container-fluid .main .content-b {
    display: block;
    padding: 0 10px;
    .banner {
      width: 100%;
    }
  }
}
</style>
